export default __webpack_public_path__ + "static/media/Template2.5c28ab79.jpg";